import React from 'react';
import {FaArrowRight} from "react-icons/all";

const Product = ({imageSrc, title, description, onClick, maxWidth, ...props}) => {
  return (
    <div
      className={`${maxWidth ? maxWidth : 'w-30 md:w-50'} flex flex-col justify-center mx-auto cursor-pointer mb-12`}
      onClick={onClick}>
      <img
        alt="product"
        src={imageSrc}
        className="w-full rounded-lg object-cover"
      />
      <div className="mt-4 justify-start align-middle">
        <div
          className="font-semibold text-sm sm:text-md md:text-xl break-normal text-brand-gray">{title}</div>
        <div className="font-normal text-sm md:text-base break-normal text-gray-500">{description}</div>
        <div {...props}
             className="flex flex-row items-center text-primary cursor-pointer hover:opacity-70 underline text-sm md:text-lg  md:mt-3">
          Porosit Tani
          <FaArrowRight className="h-7 pl-2"/>
        </div>
      </div>
    </div>
  );
};

export default Product;
